import {MESSAGE_TYPE} from '../../CodeMaster'
import {default as React, ReactNode} from 'react'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import withStyles from '@mui/styles/withStyles';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import {Colors} from '../Constants'

export const createIconWithLevel = (level?: any): ReactNode => {

    let normalized: MESSAGE_TYPE | undefined;
    if (Object.values(MESSAGE_TYPE).includes(level)) {
        normalized = level;
    } else if (typeof level === 'object' && level?.value) {
        normalized = Object.values(MESSAGE_TYPE).find(
            (v) => v.value === level.value);
    } else {
        normalized = undefined;
    }
    switch (normalized) {
        case MESSAGE_TYPE.INFORMATION:
            return <CheckCircleOutlineIcon titleAccess={'information'}/>
        case MESSAGE_TYPE.ERROR:
            return <ErrorOutlineIcon titleAccess={'error'}/>
        case MESSAGE_TYPE.WARNING:
            return <ReportProblemOutlinedIcon titleAccess={'warning'}/>
        default:
            return null
    }
}

export const DeleteAlertIcon = () => {
    return <DeleteIcon titleAccess={'delete'}/>
}

const DeleteIcon = withStyles({
    root: {
        color: Colors.Alert
    },
})(DeleteForeverIcon)
